module.exports = __webpack_public_path__ + "img/pic13.8bac072c.png";